import React from 'react';
import styles from './briqq-logo.module.css';

interface BriqqLogoProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  showBeta?: boolean;
}

const BriqqLogo: React.FC<BriqqLogoProps> = ({ size = 'medium', className = '', showBeta = false }) => {
  return (
    <div 
      className={`${styles.gradientFlowLogo} ${styles[size]} ${className}`}
    >
      briqq{showBeta && <span className={styles.betaSubscript}>β</span>}
    </div>
  );
};

export default BriqqLogo; 